import { MetricCard } from "@shared/ui";
import { AlertCircle, Clock, TrendingUp } from "lucide-react";
import styles from "./styles.module.scss";



const CREDITS_GIVEN_TOOLTIP =
  "This is the total credit given to client, this includes all the purchases done by the client, but hasnt paid yet.";

  interface FinanceMetricsProps {
    paymentOverdue: number;
    creditsGiven: number;
    leftToInvoice: number;
  }

export function FinanceMetrics({
  paymentOverdue,
  creditsGiven,
  leftToInvoice,
}: FinanceMetricsProps) {
  return (
    <div className={styles.metrics}>
      <div className={styles.metrics__grid}>
        <MetricCard
          icon={<AlertCircle size={16} />}
          label="Payment Overdue"
          value={`₹${paymentOverdue.toFixed(2)}`}
        />
        <MetricCard
          icon={<TrendingUp size={16} />}
          label="Credits Given"
          value={`₹${creditsGiven.toFixed(2)}`}
          tooltip={CREDITS_GIVEN_TOOLTIP}
        />
        <MetricCard
          icon={<Clock size={16} />}
          label="Left to Invoice"
          value={`₹${leftToInvoice.toFixed(2)}`}
        />
      </div>
    </div>
  );
}
